import React from 'react'
import { connect } from 'react-redux'
import { flash } from 'react-animations'
import { createStructuredSelector } from 'reselect'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { iconSet } from 'view/components/icons'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'
import { SelectionActions } from 'store/selection'
import { createActivityMonitorOpenSelector } from 'selectors/selectionSelectors'
import { createAllActivitiesSelector } from 'selectors/activityMonitorSelectors'
import { adminClearingAlertSelector } from 'selectors/dealSelectors'
import { isOpenFin } from 'utils'
import { Activity } from 'store/activityMonitor'

interface ActivityIndicatorState {
  newUpdate: boolean
}

interface ActivityIndicatorProps {
  activityMonitorOpen: boolean
  activities: Activity[]
  showAlertHighlight: boolean
  onToggleActivityMonitor: (activityMonitorOpen: boolean) => unknown
}

const mapStateToProps = createStructuredSelector({
  activities: createAllActivitiesSelector(),
  activityMonitorOpen: createActivityMonitorOpenSelector(),
  showAlertHighlight: adminClearingAlertSelector
})

const mapDispatchToProps = {
  onToggleActivityMonitor: SelectionActions.openActivityMonitor
}

const ActivityWrapper = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  position: relative;
`

const ActivitiesStyled = styled.div<{ showAlertHighlight: boolean }>`
  ${mixins.flexCenterContentCrossAxis};
  justify-content: space-between;
  width: 58px;
  height: 26px;
  color: white;
  padding: 5px 8px;
  background-color: ${props => (props.showAlertHighlight ? constants.ACCENT_BAD_1 : constants.ACCENT_PRIMARY)};
  border-radius: 6px;
  svg {
    width: 24px;
  }
  cursor: pointer;
`

const flashAnimation = keyframes`${flash}`

const Flasher = styled.div`
  font-size: 10px;
  font-weight: ${constants.FontWeight.Bold};
  animation: ${(props: { active: boolean }) => (props.active ? `1s ${flashAnimation} 0s infinite` : null)};
`

class ActivityIndicatorComponent extends React.Component<ActivityIndicatorProps, ActivityIndicatorState> {
  state = { newUpdate: false }

  timeout: NodeJS.Timer | null = null

  componentDidUpdate(prevProps: ActivityIndicatorProps) {
    if (prevProps.activities.length !== this.props.activities.length) {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.setState({ newUpdate: true })
      this.timeout = setTimeout(() => {
        this.setState({ newUpdate: false })
      }, 1000)
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  render() {
    const { activities, showAlertHighlight } = this.props
    return (
      <ActivityWrapper>
        <ActivitiesStyled
          data-test-id={'ActivityIndicator-ItemList-Icon'}
          showAlertHighlight={showAlertHighlight}
          onClick={this.toggleActivityMonitor}>
          {iconSet.itemList}
          <Flasher active={this.state.newUpdate}>{activities.length > 0 && activities.length}</Flasher>
        </ActivitiesStyled>
      </ActivityWrapper>
    )
  }

  private toggleActivityMonitor = () => {
    if (isOpenFin()) {
      this.props.onToggleActivityMonitor(true)
    } else {
      this.props.onToggleActivityMonitor(!this.props.activityMonitorOpen)
    }
  }
}

export const ActivityIndicator = connect(mapStateToProps, mapDispatchToProps)(ActivityIndicatorComponent)
